export default {
  homeTitle: "Philips light calculator",
  homeSubTitle: "Selecteer hieronder de berekeningen die u wilt maken.",
  helloWorld: "Nederlands",
  solarRadiationCalculation: "Daglicht calculatie",
  greenhouseTransmission: "Kastransmissie",
  greenhouseTransmissionUnit: "(%)",
  greenhouseTransmissionToolTip:
    "Het percentage daglicht dat door kan dringen tot de kas. Voor moderne Venlo kassen wordt vaak 70% gehanteerd.",
  intensityOutside: "Intensiteit buiten",
  intensityOutsideUnit: "(W/m²)",
  intensityOutsideToolTip:
    "Bereken de hoeveelheid PAR licht (binnen) uit de totale daglicht intensiteit (buiten), en vise versa. <br> PAR licht omvat al het licht met een golflengte tussen 400 en 700 nm. Deze range wordt door planten direct gebruikt voor fotosynthese.",
  prInside: "PAR binnen",
  prInsideUnit: "(μmol/m²/sec)",
  prInsideToolTip:
    "Bereken de hoeveelheid PAR licht (binnen) uit de totale daglicht intensiteit (buiten), en vise versa. <br> PAR licht omvat al het licht met een golflengte tussen 400 en 700 nm. Deze range wordt door planten direct gebruikt voor fotosynthese.",
  radiationSUM: "Som radiatie buiten",
  radiationSUMUnit: "(J/cm²/day)",
  radiationSUMToolTip:
    "Bereken de hoeveelheid daglicht (in mol) die de kas penetreert uit de hoeveelheid licht (in Joules) buiten de kas, en vise versa.",
  lightSUM: "Som licht binnen",
  lightSUMUnit: "(mol/m²/day)",
  lightSUMToolTip:
    "Bereken de hoeveelheid daglicht (in mol) die de kas penetreert uit de hoeveelheid licht (in Joules) buiten de kas, en vise versa.",
  luxToPar: "LUX-PAR omrekenen",
  luxToParInfo: "In deze omrekening is de LUX waarde gebaseerd op een gemiddeld HPS spectrum.",
  LUX: "LUX",
  LUXToolTip:
    "De eenheid LUX wordt algemeen gebruikt om de intensiteit van HPS-belichting uit te drukken.",
  PAR: "PAR",
  PARUnit: "(μmol/m²/sec)",
  PARToolTip:
    "PAR licht omvat al het licht met een golflengte tussen 400 en 700 nm. Deze range wordt door planten direct gebruikt voor fotosynthese.",
  ali: "Intensiteit assimilatielicht (HPS en LED)",
  aliMaxLighting: "Belichtingsuren",
  aliMaxLightingUnit: "(per dag)",
  aliMaxLightingToolTip:
    "De gewenste daglengte voor het gewas (bv. 18 uur voor tomaten).",
  unit: "LUX of micromol",
  lightIntensityMicro: "Lichtintensiteit",
  lightIntensityMicroUnit: "(μmol/m²/sec)",
  lightIntensityMicroToolTip: "Intensiteit assimilatiebelichting.",
  lightIntensityHPSLED: "Lichtintensiteit",
  lightIntensityHPSLEDUnit: "(HPS/LED)",
  lightIntensityHPSLEDToolTip: "Intensiteit assimilatiebelichting.",
  lightIntensitySUM: "Lichtsom",
  lightIntensitySUMUnit: "(mol/m²/day)",
  lightIntensitySUMToolTip: "Totale hoeveelheid assimilatiebelichting per dag.",
  requiredSuplementalLightLevel: "Indicatie benodigde intensiteit assimilatiebelichting",
  targetDaily: "Gewenste dagelijkse lichtsom",
  targetDailyUnit: "(mol/m²/day)",
  targetDailyToolTip:
    "De gewenste hoeveelheid PAR licht die het gewas per dag moet ontvangen.",
  supplementMaxLight: "Belichtingsuren",
  supplementMaxLightUnit: "(per dag)",
  supplementMaxLightToolTip:
    "De gewenste daglengte voor het gewas (bv. 18 uur voor tomaten).",
  naturelLight: "Natuurlijk licht binnen ",
  naturelLightUnit: "(mol/m²/day)",
  naturelLightToolTip:
    'De hoeveelheid daglicht die tot de kas doordringt. Deze kan berekend worden m.b.v. de "Solar radiation calculation".',
  supplementLight: "Indicatie benodigde intensiteit assimilatiebelichting ",
  supplementLightUnit: "(μmol/m²/sec)",
  supplementLightToolTip:
    "Dit getal weergeeft de benodigde intensiteit assimilatiebelichting om de gewenste daily light integral te bereiken.",
  copyToClipboard: "Kopieer URL naar klembord",
  exportToXLSX: "Exporteer naar Excel bestand",
  connectWithPhilips: "Connect met Philips",
  investorRelations: "Relaties met investeerders",
  careers: "Carrières",
  contactPhilips: "Neem contact op met Philips",
  siteOwner: "Site-eigenaar",
  cookiesNotice: "Cookies merken",
  privacyNotice: "Privacyverklaring",
  productSecurity: "Productbeveiliging",
  termsOfUse: "Gebruiksvoorwaarden",
  copyright: "© 2019-{n} Signify Holding. Alle rechten voorbehouden.",
  country: "Land",
  language: "Nederland - Nederlands",
  exportCalculation: "Export berekeningen",
  copyURL: "URL gekopieerd naar klembord!"
};
